export const pieChartModelsInstitutions = (data, percentage = false) => ({
  chart: { type: "pie" },
  title: { text: null },
  credits: { enabled: false },
  tooltip: {
    formatter: function () {
      const institutions = this.point.institutions || {};
      let instHtml = "";

      Object.entries(institutions).forEach(([inst, count]) => {
        instHtml += `<div>${inst}: <b>${count}</b></div>`;
      });

      return `
        <div>
          <b>${this.point.name}</b><br/>
          Total equipos: ${this.y}<br/>
          ${instHtml}
        </div>
      `;
    },
    useHTML: true,
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: {
        enabled: true,
        format: percentage
          ? "{point.name}: {point.percentage:.2f}%"
          : "{point.name}: {point.y}",
      },
    },
  },
  series: [
    {
      name: "Modelos",
      colorByPoint: true,
      data,
    },
  ],
});